export default __webpack_public_path__ + "static/media/loc_img_12.2956e9c8.jpg";